import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { useResolveJobTenantId } from './hooks/useResolveJobTenantId';
import { PatientImportStatusRouter } from './screens/PatientImportStatusRouter';

export const PatientImportDetailPage: React.FC = () => {
  const { jobId } = useParams<{ jobId: string }>();
  const tenantId = useResolveJobTenantId(jobId);

  if (!jobId) return null;
  if (!tenantId) return <Navigate to="/admin/patient-imports" replace />;

  return <PatientImportStatusRouter jobId={jobId} tenantId={tenantId} />;
};
